import { render, staticRenderFns } from "./wrzjhTable.vue?vue&type=template&id=34d51dbe&scoped=true"
import script from "./wrzjhTable.vue?vue&type=script&lang=ts"
export * from "./wrzjhTable.vue?vue&type=script&lang=ts"
import style0 from "./wrzjhTable.vue?vue&type=style&index=0&id=34d51dbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d51dbe",
  null
  
)

export default component.exports